import type { Static } from 'runtypes';
import { InstanceOf, Number, Record, String, Optional } from 'runtypes';

const AiChatRuntype = Record({
  timestamp: InstanceOf(Date),
  event: String,
  user_id: Number,
  email: String,
  session_id: String,
  response: Optional(String),
  context_metadata: String,
  message: String,
});

type AiChatType = Static<typeof AiChatRuntype>;

export { AiChatRuntype };
export type { AiChatType };
